import React, {memo, useEffect, useRef, useState} from 'react'
import "./multi-drop-new.scss"
import Close from "../../assets/images/fa-close.svg";
import {setGlobalFilter} from "../../store/slices/examSlice";
const MultiSelectDropdownNew = ({ options, selected,searchInit="",
                                    isOpenInit=false,
                                    toggleOption,searchFilter }) => {

    const [searchRef,setSearchRef] = useState(searchInit || "");
    const searchM = useRef(null);
    const [isOpen,setIsOpen] = useState(isOpenInit);

    const handleSelectCancel = (option) => {
        toggleOption(option);
    }

    const handleClose = () => {
        setIsOpen(false);
        // handleClear();
        // if(searchFilter){
        //     searchFilter(null,true);
        // }
        // console.log("MultiSelect closing",searchM.current.value,searchRef,searchFilter);
    }
    const handleClear = () => {
        searchM.current.value = '';
        handleChange("");
        searchInit = "";
    }

    const  handleChange = (value) => {
        if(searchFilter){
            searchFilter(value);
        }
        else{
            setSearchRef(value);
        }

    }

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    }

    useEffect(() => {
        if(searchM.current && !searchM.current.value) {
            searchM.current.value = searchInit;
            // searchM.current.focus();
            // console.log("MultiSelect",searchM.current.value,searchRef);
        }
        return (() => {
            if(searchM.current)
            searchM.current.value = "";
        })
    })


    return (
        <>
            <div className={`c-multi-select-dropdown-new ${isOpen?"open":""}`}>
                <div onClick={toggleDropdown} className={`c-multi-select-dropdown-new__selected ${!!selected.length?"":"empty"}`}>
                    {selected.map(optionItem => {
                        return (
                            <span key={optionItem.id} onClick={() => handleSelectCancel(optionItem)}>{optionItem.name}<img  src={Close} alt="Scholar" /></span>
                        )
                    })}

                    <div className="arrow"></div>
                </div>
                <ul className="c-multi-select-dropdown-new__options">
                    <div  className={`c-multi-select-dropdown-new__option search`}>
                        <input ref={searchM} type="text"  onChange={(e) => {
                            handleChange(e.target.value);
                        }}  placeholder="Search..."
                               className="c-multi-select-dropdown-new__option-checkbox"></input>
                        <img onClick={handleClear}  src={Close} alt="Scholar" />
                    </div>
                    <div className="c-multi-select-dropdown-new__option-main">
                        {options
                            .filter(option => {
                                if(!!!searchRef || !!!option.name)return  true;
                                return option.name.toLowerCase().indexOf(searchRef.toLowerCase()) !== -1;
                            })
                            .map(option => {
                                const isSelected = !!selected.filter(x => x.id === option.id).length;
                                // console.log("isSelected",isSelected);
                                return (
                                    <div key={option.id} className={`c-multi-select-dropdown-new__option ${isSelected?"active":""}`} onClick={() => toggleOption({ id: option.id,name: option.name })}>
                                        {/*<input type="checkbox" checked={isSelected} className="c-multi-select-dropdown-new__option-checkbox"></input>*/}
                                        <span>{option.name} <br/><small>{option.email}</small></span>
                                    </div>
                                )
                            })}
                    </div>
                    <div  className={`c-multi-select-dropdown-new__option close`}>
                       <a onClick={handleClose} >Close<img   src={Close} alt="Scholar" /></a>
                    </div>

                </ul>
            </div>
        </>
    )
}

const MultiDropdownNew = ({options,handleChange,type,searchInit="",
                              isOpenInit=false,searchFilter}) => {
    // const tempItems = selectedStore.filter(item => {
    //     return selectedValues.includes(item.name);
    // }).map(x  => x.id);
    const savedSelectedItem = JSON.parse(localStorage.getItem(`multi-selected`) || "[]");
    const [selectedStore, setSelectedStore] = useState(savedSelectedItem);
    const [selected, setSelected] = useState(selectedStore);
    // console.log("MultiDropdownNew Init",selectedStore,selected,selectedValues,savedSelectedItem);
    const saveSelected = (newArray) => {
        localStorage.setItem("multi-selected", JSON.stringify(newArray));
        setSelectedStore(newArray);
    }
    const toggleOption = (optionItem) => {
        setSelected(prevSelected => {
            // if it's in, remove
            let newArray = [...prevSelected];
            const optionItemCheck = !!newArray.filter(x => x.id === optionItem.id).length;
            // console.log("check Exist",newArray,optionItem,optionItemCheck);
            if (optionItemCheck) {
                newArray = newArray.filter(x => x.id !== optionItem.id);
            } else {
                if(type === 1){
                    newArray = [];
                }
                newArray.push(optionItem)
            }
            saveSelected(newArray);
            return  newArray;
        });

    }

    useEffect(() => {
        const finalSelected = selected.map(x  => x.id);
        // console.log("finalSelected",finalSelected);
        handleChange(finalSelected);
    }, [selected]);
    useEffect(() => {
        return (() => {
            // console.log("destroy multi: ");
        })
    },[]);

    return (
        <MultiSelectDropdownNew
            options={options}
            selected={selected}
            toggleOption={toggleOption} searchFilter={searchFilter} isOpenInit={isOpenInit}
        searchInit={searchInit}/>
    )
}

export default memo(MultiDropdownNew);
